import { render, staticRenderFns } from "./FormSectionTitle.vue?vue&type=template&id=4d44feb5&scoped=true&functional=true&"
var script = {}
import style0 from "./FormSectionTitle.vue?vue&type=style&index=0&id=4d44feb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4d44feb5",
  null
  
)

export default component.exports